// extracted by mini-css-extract-plugin
var _1 = "Editable__editContainer--ysErL";
var _2 = "Editable__error--mkWL3";
var _3 = "Editable__inputColor--iwvel";
var _4 = "Editable__main--YHclG";
var _5 = "Editable__nameInput--gVHre";
var _6 = "Editable__nameInputSmaller--HLfxe";
var _7 = "Editable__placeholderText--HZ93B";
var _8 = "Editable__saveButton--n7qb7 OfficeGeneral__clearBlue--O9nNR OfficeGeneral__button--BZOmo OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk OfficeGeneral__textSizeB--Ye78Y CoreGeneral__textSizeB--joAuE OfficeGeneral__centeredRow--GA99n OfficeGeneral__centeredRowBase--jxfGw OfficeGeneral__clearBlueBase--zXwuL";
var _9 = "Editable__saveContainer--mhLEe";
var _a = "Editable__text--p7Xpt";
export { _1 as "editContainer", _2 as "error", _3 as "inputColor", _4 as "main", _5 as "nameInput", _6 as "nameInputSmaller", _7 as "placeholderText", _8 as "saveButton", _9 as "saveContainer", _a as "text" }
